const generalRoute = {
  path: "/",
  component: () =>
    import(/* webpackChunkName: "home" */ "@/views/layout/Layout.vue"),
  children: [
    {
      path: "",
      name: "Home",
      meta: { title: "तरकारी तथा फलफुल कृषि बजार दाङ | गृह " },

      component: () =>
        import(/* webpackChunkName: "home" */ "@/views/general/HomeScreen.vue"),
    },

    {
      path: "/not-permitted",
      name: "NotPermitted",
      component: () =>
        import(
          /* webpackChunkName: "home" */ "@/views/general/misc/NotPermittedScreen.vue"
        ),
    },
  ],
};

export default generalRoute;
